import { getLayer } from '../layerService.js';

export default class ObjectResizeCommand {
    constructor({ objectUuid, prevX, prevY, prevW, prevH, finalX, finalY, finalW, finalH, pageUuid }) {
        this.id = crypto.randomUUID();
        this.timestamp = Date.now();
        this.description = 'Resize';
        this.category = 'layout';
        this.objectUuid = objectUuid;
        this.affectedUuids = [objectUuid];
        this.pageUuid = pageUuid ?? null;
        this.prevX = prevX; this.prevY = prevY;
        this.prevW = prevW; this.prevH = prevH;
        this.finalX = finalX; this.finalY = finalY;
        this.finalW = finalW; this.finalH = finalH;
    }

    _apply(x, y, w, h) {
        const layer = getLayer();
        if (!layer) return;
        const node = layer.findOne('#' + this.objectUuid);
        if (!node) return;
        node.x(x);
        node.y(y);
        node.setNewSize?.({ width: w, height: h });
        node.fire('width');
        node.fire('height');
        node.setObjectSize?.();
        node.getLayer()?.batchDraw();
    }

    execute() {
        this._apply(this.finalX, this.finalY, this.finalW, this.finalH);
    }

    undo() {
        this._apply(this.prevX, this.prevY, this.prevW, this.prevH);
    }

    toJSON() {
        return {
            type: 'ObjectResize',
            id: this.id,
            timestamp: this.timestamp,
            payload: {
                objectUuid: this.objectUuid,
                prevX: this.prevX, prevY: this.prevY,
                prevW: this.prevW, prevH: this.prevH,
                finalX: this.finalX, finalY: this.finalY,
                finalW: this.finalW, finalH: this.finalH,
            },
        };
    }
}
